export default __webpack_public_path__ + "static/media/defaultProductImage.0651816a.svg";